// extracted by mini-css-extract-plugin
module.exports = {"grid_div":"GridView_grid_div__zwUqw","grid_div_mobile":"GridView_grid_div_mobile__2RQ9t"};